import Duck from 'extensible-duck';
import { types as authTypes } from '../../App/ducks/authDuck';

const baseDuck = () =>
  new Duck({
    reducer: (state, action, { initialState }) => {
      if (action.type === authTypes.LOGOUT) {
        return initialState;
      } else {
        return state;
      }
    },
  });

export default baseDuck;
